import { useEffect, useState } from "react";

import { type Reference, loadReferences } from "@frontend/lib/references";

export function useTaskTypes(
  serviceGroupId: number | null,
  fallback: Reference[],
): Reference[] {
  const [byGroup, setByGroup] = useState<Record<number, Reference[]>>({});

  useEffect(() => {
    if (null === serviceGroupId) {
      return;
    }

    let current = true;

    void loadReferences("taskTypes", { serviceGroupId }).then((rows) => {
      if (current) {
        setByGroup((previous) => ({ ...previous, [serviceGroupId]: rows }));
      }
    });

    return () => {
      current = false;
    };
  }, [serviceGroupId]);

  return null === serviceGroupId ? fallback : (byGroup[serviceGroupId] ?? []);
}
